import React from 'react';
import { Modal, Button, Image } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { ModalSize } from '../../utils/constants/StyleConstant';
import { EMButton } from '../button/EMButton';
import { ModalStackPropsBase } from '../modal/ModalStackProvider';

export interface IOptionModalData {
  modalSize?: ModalSize;
  title?: string;
  image?: string;
  firstOptionText?: string;
  secondOptionText?: string;
  unscrollable?: boolean;
  isSingleButton?: boolean;
  isActive?: boolean;
  isSingleButtonReturnFirstOptionClick?: boolean;
}

export interface IOptionModalElementID {
  title?: string;
  btnPrimary?: string;
  btnSecondary?: string;
}

interface IOptionModalProps
  extends ModalStackPropsBase<unknown, unknown>,
  React.PropsWithChildren<{}> {
  data: IOptionModalData;
  elementID?: IOptionModalElementID;
  isLoading?: boolean;
  hasCloseBtn: boolean;
  onClose: () => void;
  elementRef?: any;
  onFirstOptionClick?: () => void;
  onSecondOptionClick?: () => void;
  goBackHomePage?: boolean;
}

export function OptionModal(
  props: IOptionModalProps,
): React.FunctionComponentElement<IOptionModalProps> {
  const {
    data,
    elementID,
    onClose,
    elementRef,
    children,
    show,
    hasCloseBtn,
    onFirstOptionClick,
    onSecondOptionClick,
    goBackHomePage,
  } = props;

  const { t } = useTranslation();

  const handleFirstOption = () => {
    if (onFirstOptionClick) {
      onFirstOptionClick();
    }
  };

  const handleSecondOption = () => {
    if (onSecondOptionClick) {
      onSecondOptionClick();
    }
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <>
      {
        <Modal
          show={show}
          size={data.modalSize === ModalSize.MD ? undefined : data.modalSize}
          dialogClassName={data.modalSize === ModalSize.MD ? 'modal-md' : ''}
          onHide={hasCloseBtn ? handleCancel : () => { }}
          scrollable={!data.unscrollable}
        >
          <Modal.Header className="modal-header-image">
            <div className="modal-image-illustrate">
              <Image src={data.image} width={data.isActive ? 157 : 405} />
            </div>
            {hasCloseBtn && (
              <div className="modal-btn-close" onClick={handleCancel}>
                <button type="button" data-dismiss="modal" className="btn-icon">
                  <i className="icon-close"></i>
                </button>
              </div>
            )}
          </Modal.Header>

          <Modal.Body className="mt-0 pb-0 pt-3 px-3" ref={elementRef}>
            <div className="font-large color-primary" id={elementID?.title}>
              {data.title ? t(data.title) : 'Title'}
            </div>
            {children}
          </Modal.Body>

          <Modal.Footer>
            <div className="float-right">
              {data.isSingleButton === true ? (
                <></>
              ) : (
                <Button
                  id={elementID?.btnSecondary}
                  variant="secondary"
                  onClick={goBackHomePage ? onClose : handleSecondOption}
                >
                  {data.secondOptionText ? t(data.secondOptionText) : t('Common.Button.Cancel')}
                </Button>
              )}

              <EMButton
                id={elementID?.btnPrimary}
                type="primary"
                onClick={
                  hasCloseBtn
                    ? (data.isSingleButton && !data.isSingleButtonReturnFirstOptionClick)
                      ? onClose
                      : handleFirstOption
                    : handleFirstOption
                }
              >
                {data.firstOptionText ? t(data.firstOptionText) : t('Common.Button.Confirm')}
              </EMButton>
            </div>
          </Modal.Footer>
        </Modal>
      }
    </>
  );
}
